import React, { useEffect, useState } from 'react'
import { makeGetCall, makeNextPageCall } from '../../../effects/requests';
import { endPoints } from '../../../utils/endpoints';
import { ApiResponseType } from '../../../types';
import InfiniteScroll from 'react-infinite-scroll-component';
import PerScriptFilterDropdown from './PerScriptFilterDropdown';
import { emptyFunction, groupByEpisode } from '../../../utils';
import NoData from '../../../global/ui/NoData';

const PerScriptCollection = ({ collectionDetails, onClick, onBack }: any) => {

    const [allData, setAllData] = useState<any>([])
    const [next, setNext] = useState<any>(null)

    const [episodes, setEpisodes] = useState<any>([])
    const [selectedEpisodes, setSelectedEpisodes] = useState<any>(null)
    const [selectedSences, setSelectedSences] = useState<any>(null)

    const fetchMoreData = () => {
        if (!next) return;

        makeNextPageCall(next, false, true).then(
            (res: ApiResponseType<any>) => {
                setAllData([...allData, ...res.results]);
                setNext(res?.next);
            }
        );
    };

    const fetchLoc = () => {
        const url = `${endPoints.SCRIPT_SCENE_COLLECTION_LOCATIONS}?collection_id=${selectedEpisodes?.episode_id}`
        makeGetCall(url).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                setAllData(res?.results);
                setNext(res?.next)
            }
        }).catch(emptyFunction)
    }

    const fetchScriptScene = () => {
        const url = `${endPoints.LOCATION_SCRIPT_SCENE}?script_id=${collectionDetails?.id}`
        makeGetCall(url).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                const groupedEpisodes = groupByEpisode(res?.results?.length > 0 ? res?.results : []);
                setEpisodes(groupedEpisodes);
            }
        }).catch(emptyFunction)
    }

    useEffect(() => {
        if (collectionDetails?.id)
            fetchScriptScene();
    }, [collectionDetails?.id]);

    useEffect(() => {
        if (selectedSences?.id) {
            fetchLoc();
        } else {
            setAllData([])
        }
    }, [selectedSences?.id])

    return (
        <div>
            <div className="fd-row">
                <PerScriptFilterDropdown
                    icon={<img src={'/assets/images/folder_new.svg'} />}
                    placeholder="Select script"
                    options={[{ label: collectionDetails?.name, value: collectionDetails?.name }]}
                    value={collectionDetails?.name || ''}
                    onChange={emptyFunction}
                />
                <PerScriptFilterDropdown
                    icon={<img src={'/assets/images/play_new.svg'} />}
                    placeholder="Select episode"
                    options={episodes}
                    value={selectedEpisodes?.value || ''}
                    onChange={(el) => {
                        setSelectedEpisodes(el);
                        setSelectedSences(null)
                    }}
                    disabled={!collectionDetails?.name}
                />
                <PerScriptFilterDropdown
                    icon={<img src={'/assets/images/image_new.svg'} />}
                    placeholder="Select scene"
                    options={selectedEpisodes?.scenes?.length > 0 ? selectedEpisodes?.scenes : []}
                    value={selectedSences?.value || ''}
                    onChange={setSelectedSences}
                    disabled={!selectedEpisodes?.value}
                    disabledMessage='Please select episode first.'
                />
            </div>
            <div style={{ marginBottom: 10 }} className="ld-breadcrumb">
                <button type='button' onClick={onBack} className="ld-breadcrumb__link">Per script collections</button>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9 18 15 12 9 6" />
                </svg>
                <span className="ld-breadcrumb__current">{collectionDetails?.name || ''}</span>
            </div>
            {allData?.length > 0
                ?
                <InfiniteScroll
                    dataLength={allData}
                    next={fetchMoreData}
                    hasMore={next ? true : false}
                    loader={null}
                    scrollableTarget="scrollableId"
                >
                    <div className={`lv-grid`}>
                        {allData?.map((loc: any, index: any) => {
                            return (
                                <div
                                    key={loc?.id}
                                    onClick={() => onClick(loc, selectedEpisodes?.episode_id)}
                                    className='lv-card'
                                >
                                    <img
                                        src={loc?.thumbnail || '/assets/images/yellow-6th.png'}
                                        alt={loc.name}
                                        className="lv-card__img"
                                    />
                                    <div className="lv-card__overlay">
                                        <div className="lv-card__info">
                                            <span className="lv-card__name">{loc?.name}</span>
                                            <span className="lv-card__city">{loc?.address}</span>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </InfiniteScroll>
                :
                <NoData message='Please select an episode and scene to view the script locations.' />
            }
        </div>
    )
}

export default PerScriptCollection